import { useMemo } from 'react';

export const useDuvalPentagonSeries = (variables, variablesIndex, configuration) => {
  return useMemo(
    () =>
      variables.map(({ id, aggregate, label, unit, decimals }) => {
        const { name } = (variablesIndex || {})[id] || {};
        const seriesId = `${id}.${aggregate}`;
        const displayUnit =
          unit === 'variable-default' ? (variablesIndex || {})[id]?.unit || 'number' : unit;

        return {
          variableId: id,
          id: seriesId,
          label: label || name,
          decimals: decimals || 'auto',
          unit: displayUnit,
          aggregate,
        };
      }),
    [variables, variablesIndex, configuration]
  );
};
export default useDuvalPentagonSeries;
